//
const IS_LOCAL = process.env.NODE_ENV !== 'production';

// const API_BASE_URL = 'http://10.200.2.2:8890/';
// API_BASE_URL is connecting with wmanager
const API_BASE_URL = IS_LOCAL
  ? 'http://localhost:7373/'
  : 'https://wamadmin-api.wisdomera.io/';

const API_WMANAGER_URL = IS_LOCAL
  ? 'http://localhost:8897/'
  : 'https://manager-api.wisdomera.io/';

const CLIENT_ID = 'wisdomhs';
const CLIENT_SECRET = 'wisdomera';
const GRANT_TYPE = 'password';

const WDMR_URL = IS_LOCAL ?
  // 'http://localhost:8077/' :
  'https://wdmr.wisdomera.io/' :
  'https://wdmr.wisdomera.io/';


const WDMR_LINKS = {
  'record': WDMR_URL + '#/wdmr-record?',
  'show': WDMR_URL + '#/wdmr-show?'
};

const SWIFT_BASE_URL = IS_LOCAL
  ? 'http://localhost:12345/v1/AUTH_test/'
  : 'https://s3.wisdomera.io/v1/AUTH_test/';
  
/*
const API_BASE_URL = IS_LOCAL
  ? 'http://localhost:8888/'
  : 'https://api.wisdomera.io/';

const SWIFT_BASE_URL = IS_LOCAL
  ? 'http://localhost:12345/v1/AUTH_test/'
  : 'https://s3.wisdomera.io/v1/AUTH_test/';

const CLIENT_ID = 'wisdomhs';
const CLIENT_SECRET = 'wisdomera';
const GRANT_TYPE = 'password';
*/

export {
  API_WMANAGER_URL,
  IS_LOCAL,
  API_BASE_URL,
  SWIFT_BASE_URL,
  CLIENT_ID,
  CLIENT_SECRET,
  GRANT_TYPE,
  WDMR_LINKS,
  WDMR_URL
};
